import { typography } from '../global/typography';
import { palette } from '../global/palette';
export const MuiDialogTitle = {
    MuiDialogTitle: {
        styleOverrides: {
            root: Object.assign(Object.assign({}, typography.h5), { padding: '24px 36px 16px 24px', color: palette.common.black, display: 'flex', justifyContent: 'space-between', '& svg': {
                    width: 12,
                    height: 12,
                    fill: palette.common.black,
                }, '& Button': {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                } }),
        },
    },
};
